<template>
	<panel-base :checked="data!==null" :ok="data && data.length===0" :loading="loading" @start="start" @stop="stop">
		<template #heading>
			Станции със сградна инст. извън интервала 0-100%
			<span v-if="data">
				({{ data.length }})
			</span>
		</template>
		<template #content v-if="data">
			<station-list
				:utility="utility"
				:session="session"
				:fields="['sgri_percent_izr']"
				:items="data"
			/>
		</template>
	</panel-base>
</template>
<script>
import expansionPanelShort from "@/ittijs/ExpansionPanelShort";
import PanelBase from "@/views/report/checks/panelBase";
import checkMixin from "@/views/report/checks/checkMixin";
import StationList from "@/views/report/checks/station-list";

export default {
	components: {StationList, PanelBase},
	mixins: [
		expansionPanelShort,
		checkMixin(
			(self, getController) => self.imodel.percentSgr(self.session, getController)
		),
	],
	props: [
		'utility',
		'session',
		'imodel',
	],
	watch: {
		utility(){ this.reset() },
		session(){ this.reset() },
	},
}
</script>